export default __webpack_public_path__ + "static/media/message_connector.5bc0d620.svg";